import { render, staticRenderFns } from "./mixtureSettings.vue?vue&type=template&id=5ff45c2e"
import script from "./mixtureSettings.vue?vue&type=script&lang=js"
export * from "./mixtureSettings.vue?vue&type=script&lang=js"
import style0 from "./mixtureSettings.vue?vue&type=style&index=0&id=5ff45c2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports